import { useEffect, useState } from "react";

const useDataFetcher = <T>(cb: () => Promise<Response>) => {
  const [data, setData] = useState<T | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(undefined);

  const fetchFunction = async () => {
    setData(undefined);
    setLoading(true);
    setError(undefined);
    try {
      const response = await cb();
      if (response.status !== 200) {
        throw new Error("[fetchFunction] Internal Server Errors");
      }
      const data = await response.json();
      setData(data);
      setLoading(false);
      setError(undefined);
    } catch (e) {
      setData(undefined);
      setError(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFunction();
  }, []);

  return { data, loading, error, setData, fetchFunction };
};

export default useDataFetcher;
